import(/* webpackMode: "eager", webpackExports: ["GamePageContent"] */ "/workspace/src/app/games/game-page-content.tsx");
